import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                福利视频
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              福利视频网站为您汇聚海量免费高清视频资源，覆盖影视、综艺、短片等多种类型内容，无需注册即可畅享优质视频福利。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-100 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors flex items-center gap-2"
                  >
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className={`${cat.icon} text-xs`}></i>
                    </div>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-100 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  首页推荐
                </Link>
              </li>
              <li>
                <Link to="/category/dianshi" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  热门电视剧
                </Link>
              </li>
              <li>
                <Link to="/category/dianying" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  精选电影
                </Link>
              </li>
              <li>
                <Link to="/category/zongyi" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  综艺节目
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-100 mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-xs"></i>
                </div>
                contact@fulishipin.com
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-xs"></i>
                </div>
                400-888-9999
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line text-xs"></i>
                </div>
                北京市朝阳区光华路88号
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} 福利视频 Fulishipin.com 版权所有 | 京ICP备2024000001号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors text-sm" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors text-sm" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors text-sm" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}